import React, { useState } from "react";
import PaginationButton from "../commanComponents/buttons/PaginationButton";
import BorderButton from "../commanComponents/buttons/BorderButton";
import SelectMine from "../commanComponents/SelectMine";
import svgData from "../constants/utilities/svgData";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { PaginationContext } from "../constants/context/PaginationProvider";
import useDebounce from "../constants/helpers/useDebounce";
import toast from "react-hot-toast";
import { communication } from "../constants/apis/communication";
import Loader from "../commanComponents/Loader";
import { getUserDetails } from "../constants/helpers/getUserDetails";

export default function RateMaster() {
  const navigate = useNavigate();
  const { globalSearchString } = React.useContext(PaginationContext);
  const [page, setPage] = useState(1);
  const debouncedSearchTerm = useDebounce(globalSearchString, 1000, setPage);
  const [selectedMine, setSelectedMine] = useState(getUserDetails()?.mineId || "");
  const pageLimit = process.env.REACT_APP_PUBLIC_LIMIT;

  const { data: rateMaster, isFetching } = useQuery(["getRateMasterList", page, debouncedSearchTerm], () => communication?.getRateMasterList({ searchString: debouncedSearchTerm, page }), {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.data?.status === "JWT_INVALID") {
        toast.error(`Failed: ${data?.data?.message}`);
      } else if (data?.data?.status === "FAILED") {
        toast.error(`Failed: ${data?.data?.message}`);
      }
    },
    onError: (error) => {
      toast.error(`Failed: ${error?.message}`);
    },
  });

  return (
    <>
      {isFetching && <Loader />}
      <div className="pageWrapper">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 bg-white p-3 rounded comman-box-shadow">
          <div className="d-flex gap-3 flex-wrap">
            <BorderButton text="Employee Master" icon={svgData?.employeeMasterIcon} onClick={() => navigate("/panel/settings/employee-master")} isActive={false} />
            <BorderButton text="Equipment Master" icon={svgData?.hammerIcon} onClick={() => navigate("/panel/settings/equipment-master")} isActive={false} />
          </div>
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <SelectMine selectedMine={selectedMine} onChange={(e) => setSelectedMine(e.target.value)} />
            <PaginationButton setPage={setPage} page={page} totalPages={rateMaster?.data?.totalPages} />
            <div className="d-flex gap-2 lightBlueColor align-items-center cursor-pointer" onClick={() => navigate(-1)} style={{ marginLeft: "12px" }}>
              <p style={{ fontSize: "16px", margin: 0, fontWeight: "600" }}>Back</p>
              <div>{svgData?.backButton}</div>
            </div>
          </div>
        </div>

        <div className="mt-2">
          <div className="tableWrapper comman-box-shadow" style={{ position: "relative", height: "70vh" }}>
            <table style={{ minWidth: "2400px" }}>
              <thead>
                <tr>
                  <th className="text-center col_80px">Sr. No.</th>
                  <th className="col_150px">Job Code</th>
                  <th className="col_150px">Rate</th>
                  <th className="col_200px">Start Date</th>
                  <th className="col_200px">Personnel Area</th>
                  <th className="col_200px">Personnel Subarea</th>
                  <th className="col_200px">End Date</th>
                  <th className="col_200px">Job Type</th>
                  <th className="col_200px">Job Category</th>
                  <th className="col_400px">Job Description</th>
                  <th className="col_150px">Unit</th>
                  <th className="col_150px">Currency Key</th>
                </tr>
              </thead>
              <tbody>
                {rateMaster?.data?.rate?.map((ele, index) => {
                  return (
                    <tr className={index % 2 === 0 && "skyBlueTrBg"}>
                      <td className="text-center">{(page - 1) * pageLimit + (index + 1)}</td>
                      <td className="text-uppercase">{ele?.jobCode || "--"}</td>
                      <td className="text-uppercase">{ele?.rate || "--"}</td>
                      <td className="text-uppercase">{ele?.startDate || "--"}</td>
                      <td className="text-uppercase">{ele?.personnelArea || "--"}</td>
                      <td className="text-uppercase">{ele?.personnelSubarea || "--"}</td>
                      <td className="text-uppercase">{ele?.endDate || "--"}</td>
                      <td className="text-uppercase">{ele?.jobType || "--"}</td>
                      <td className="text-uppercase">{ele?.jobCategory || "--"}</td>
                      <td className="text-uppercase">{ele?.jobDescription || "--"}</td>
                      <td className="text-uppercase">{ele?.unit || "--"}</td>
                      <td className="text-uppercase">{ele?.currency || "--"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {(!rateMaster?.data?.rate || rateMaster?.data?.rate?.length == 0) && <h6 className="text-center mt-3">No Data Available</h6>}
          </div>
        </div>
      </div>
    </>
  );
}
